var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"usage-report\">\n<div class=\"ur-header\">\n<h1>Usage Reports</h1>\n</div>\n<div class=\"ur-container\">\n<hap-icon svg=\"loader\" spin=\"true\" class=\"hap-icon-2x\" ng-if=\"loading\"></hap-icon>\n<div ng-if=\"!loading\">\n<iframe width=\"1140px\" height=\"980\" src=\"{{url}}\" frameborder=\"0\" style=\"margin: 0 auto\"></iframe>\n</div>\n</div>\n</div>\n";
var id1="app/usage-report/usage-report.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;